import React, { useEffect, useState } from 'react'
import Header from '../../component/Header';
import { Link } from 'react-router-dom';


export default function Personal(props) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <Header />
            <section className='banner-section-about top bottom p-l-r'>
                <div className='about-banner-content about-banner-content_new'>
                    {/* <img src={require('../../assets/images/frame1.png')} /> */}
                    <h1 className='about-page-heading'>
                        We would be your pocket-sized wellness companion.</h1>
                    <p className='paragraph paragraph-font'>Subscription with Us would provide you with access to wellness content, an opportunity to become a podcaster and book a Talk to me session with our wellness experts </p>
                    <div className='banner-img-page'>
                        <img src={require('../../assets/images/2-min.png')} />
                    </div>

                </div>
            </section>
            <section className='story-section benefits-section bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <div className='left-section'>
                                <div class="mental-health-content">
                                    <h3 class="heading2 text_gradient">
                                        Subscription Benefits
                                    </h3>
                                    <div className='right-section-2'>
                                        <p className='paragraph mt-5'>
                                            We empower individuals with principles of balance and well-being to improve their overall health.
                                        </p>
                                        <p className='paragraph'><strong>Explore the goodness of ayurveda and experience the change.</strong></p>
                                        <p className='paragraph paragraph-2'>
                                            Our platform is forever evolving, new wellness content, podcasts and live sessions are added monthly and new experts join us quarterly. Our contents are based around customer feedback, so we are happy to work with you on any specific requirements you may have.
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='col-lg-7 d-none'>
                            <div className='right-section-2'>
                                {/* <div className='right-section_box'>
                                    <img src={require('../../assets/images/600x800.jpg')} />
                                </div> */}

                            </div>
                        </div>
                        <div className='col-lg-7 mt-5'>
                            <div className='right-section right_section_with_icon'>
                                {/* <h4>- 1000+ Wellness Exercises</h4> */}
                                <ul>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Wellness-Exercises.png')} alt='Wellness-Exercises' /></div><p>1000+ Wellness Exercises</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Mood-created-music.png')} alt='Mood-created-music' /></div><p>500+ Mood created music</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Daily-Quotes.png')} alt='daily-quotes' /></div><p>800+ Daily Quotes </p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Southing-Sounds.png')} alt='Southing-Sounds' /></div><p>100+ Southing Sounds</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Podcasts-with-Experts.png')} alt='podcast-experts' /></div><p>100+ Interactive Podcasts with Experts</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Meditations-&-Breath.png')} alt='Meditations-&-Breath-exercises' /></div><p>Meditations & Breath exercises</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Kids-wellness.png')} alt='Kids-wellness' /></div><p>800+ Kids wellness content</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Recipes-&-Nutritional-advice.png')} alt='Healthy-Recipes-&-Nutritional' /></div><p>800+ Healthy Recipes & Nutritional advice</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Astrological-wellness.png')} alt='Astrological-wellness' /></div><p>600+ Astrological wellness content</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Psychometrics-tests.png')} alt='Psychometrics-tests' /></div><p>25+ Psychometrics tests </p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Gratitude-Journal.png')} alt='Gratitude-Journal' /></div><p>Gratitude Journal</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/consultation-with-our-experts.png')} alt='consultation-with-our-experts' /></div><p>1-1 consultation with our experts</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/community-Updates.png')} alt='Exclusive-community-Updates' /></div><p>Exclusive community Updates</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/live-session.png')} alt='live-session' /></div><p>Premium Pass to live session</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/personal/Become-a-Podcaster.png')} alt='Become-a-Podcaster' /></div><p>Become a Podcaster and share your story</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='story-section benefits-section benefits-section-two top bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        {/* <div className='col-lg-7'>
                            <div className='right-section-2'>
                                <div className='right-section_box'>
                                    <img src={require('../../assets/images/600x800.jpg')} />
                                </div>
                            </div>
                        </div> */}
                        <div className='col-lg-5'>
                            <div className='left-section'>
                                <div class="mental-health-content">
                                    <h3 class="heading2 text_gradient">
                                        Why The Beyond Lifestyle
                                    </h3>
                                    <div className='right-section-2'>
                                        <p className='paragraph mt-5'>
                                            We empower individuals with principles of balance and well-being to improve their overall health.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-7 mt-5'>
                            <div className='right-section'>
                                {/* <h4>- 1000+ Wellness Exercises</h4> */}
                                <ul>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Your wellness companion anywhere, anytime!</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Multiple Genres ticked in one app</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Improved Sleep</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Mindfulness path made simple</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Redused stress levels</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Simple to use content</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Suitable for all age groups</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Small Time investment required</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>24*7 Support for your wellness journey</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Expert Backend Content</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Mind-Body - Soul Synergy</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Daily Micro-Actions for Big Change</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Dynamic Life Themes</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Progress You Can Feel & See</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Built for Modern Lives</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Grounded in Science and Ancient Wisdom</p></li>
                                </ul>
                            </div>
                        </div>
                        <div className='dialogue_box mt-5'>
                            <Link to='/plans' className='common_btn'>Try for Free<i class="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className='banner-section-about top get_download_box bottom p-l-r'>
                <div className='about-banner-content about-banner-content_new pt-0'>
                    {/* <img src={require('../../assets/images/frame1.png')} /> */}
                    <h1 className='about-page-heading'>
                        Unleash the Ayurvedic Living for longer and healthier life.</h1>
                    <div className='banner-img-page'>
                        <img src={require('../../assets/images/1-min.png')} />
                    </div>
                    <div className='stats-box-1'>
                        <ul>
                            <li>
                                <div className='count-up-box'>
                                    <h5>Wellness Journey<br /> Started by</h5>
                                    <h3 className='number_b'>1M+ Users</h3>
                                </div>
                            </li>

                            <li>
                                <div className='count-up-box'>
                                    <h5>Harmonies<br /> Created</h5>
                                    <h3 className='number_b'>1.6k+</h3>
                                </div>
                            </li>
                            <li>
                                <div className='count-up-box'>
                                    <h5>Expert Led<br /> Sessions</h5>
                                    <h3 className='number_b'>1000+</h3>
                                </div>
                            </li>
                            <li>
                                <div className='count-up-box'>
                                    <h5>Most Watched<br /> Feature</h5>
                                    <h3>Podcast & My Diary</h3>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>

        </>
    )
}
